import React, {useEffect, useState} from "react";
import {Accordion} from "react-bootstrap";
import {NavLink, useLocation} from "react-router-dom";
import styled from "styled-components";
import MobileMenu from "./MobileMenu";

const MyComponent = ({isOpen, handleMenuOpen, setOpen, path}) => {
    const [activeKey, setActiveKey] = useState(null);
    const [activeRoute, setActiveRoute] = useState(false)
    const [activeWritingsRoute, setWritingsActiveRoute] = useState(false)
    const [activeEventsRoute, setEventsActiveRoute] = useState(false)
    const location = useLocation();

    const handleToggle = (key) => {
        setActiveKey((prevKey) => (prevKey === key ? null : key));
    };


    useEffect(() => {
        setActiveRoute(/^\/(typology|by-year|by-scale|by-locatio)(\/|$)/.test(location.pathname));
        setWritingsActiveRoute(/^\/(space|context|urban|material|rural)(\/|$)/.test(location.pathname));
        setEventsActiveRoute(/^\/(upcoming-event|past-event)(\/|$)/.test(location.pathname));
    }, [location.pathname]);


    return (
        <>
            <StyledComponent activeRoute={activeRoute} handleMenuOpen={handleMenuOpen} isOpen={isOpen}>
                <ul>
                    <li>
                        <NavLink exact to="/" activeClassName="active-link">
                            About
                        </NavLink>
                    </li>
                    <li>
                        <Accordion activeKey={activeKey}>
                            <AccordionItem
                                title="Architecture"
                                eventKey="0"
                                activeRoute={activeRoute}
                                handleToggle={handleToggle}
                                links={[
                                    {to: "/typology", text: "By Typology"},
                                    {to: "/by-year", text: "By Year"},
                                    {to: "/by-scale", text: "By Scale"},
                                    {to: "/by-location", text: "By Location"},
                                ]}
                            />
                            <AccordionItem
                                title="Writings"
                                eventKey="1"
                                activeWritingsRoute={activeWritingsRoute}
                                handleToggle={handleToggle}
                                links={[
                                    {to: "/space", text: "Space"},
                                    {to: "/context", text: "Context"},
                                    {to: "/urban", text: "Urban"},
                                    {to: "/material", text: "Material"},
                                    {to: "/rural", text: "Rural"},
                                ]}
                            />
                            <AccordionItem
                                title="Events"
                                eventKey="2"
                                activeEventsRoute={activeEventsRoute}
                                handleToggle={handleToggle}
                                links={[
                                    {to: "/upcoming-event", text: "Upcoming Events"},
                                    {to: "/past-event", text: "Past Events"},
                                ]}
                            />
                        </Accordion>
                    </li>
                    <li className={'mt-2'}>
                        <NavLink to="/contact" activeClassName="active-link">
                            Contact
                        </NavLink>
                    </li>
                </ul>
                <MenuBottom/>
            </StyledComponent>
            <StyledMobileMenu isOpen={isOpen} className={'mobile-menu'}>
                <MobileMenu handleMenuOpen={handleMenuOpen} setOpen={setOpen} isOpen={isOpen}/>
            </StyledMobileMenu>
        </>
    );
};



const StyledMobileMenu = styled.header`
    height: 100%;
    transform: translateX(${props => props.isOpen ? '0%' : '-100%'});
    transition: transform 0.3s;
`

const AccordionItem = ({title, eventKey, handleToggle, links, activeRoute, activeWritingsRoute, activeEventsRoute, subRoute}) => (

    <Accordion.Item eventKey={eventKey}>
        <Accordion.Header onClick={() => handleToggle(eventKey)}>
            <NavLink
                style={{
                    color: activeRoute || activeWritingsRoute || activeEventsRoute ? '#000' : undefined,
                    fontWeight: activeRoute || activeWritingsRoute || activeEventsRoute  ? 'bold' : undefined
                }}
                activeClassName={subRoute ? 'active-link' : 'active-link'}
                to={`/${title.toLowerCase()}`}
            >
                {title}
            </NavLink>

        </Accordion.Header>
        <Accordion.Body>
            <ul className="submenu">
                {links.map((link) => (
                    <li key={link.to}>
                        <NavLink
                            exact={link.to === '/typology/' && '/by-year/' && '/by-scale/' && '/by-location/ && \'/space/ && \'/context/ && \'/urban/ && \'/material/ && \'/rural/'} // Only use "exact" for the `/typology` route
                            to={link.to}
                            activeClassName="active-link"
                        >
                            {link.text}
                        </NavLink>

                    </li>
                ))}
            </ul>
        </Accordion.Body>
    </Accordion.Item>
);

const MenuBottom = () => (
    <div className="menu-bottom">
        <div className="menu-bottom__social">
            <p>Follow Us</p>
            <SocialLinks/>
        </div>
    </div>
);


const SocialLinks = () => (
    <div className="social">
        <ul>
            <li><a href="#">
                <svg id="_001-facebook_1_" data-name="001-facebook(1)" xmlns="http://www.w3.org/2000/svg" width="25"
                     height="25" viewBox="0 0 25 25">
                    <g id="Group_13" data-name="Group 13">
                        <path id="Path_1" data-name="Path 1"
                              d="M12.5,0A12.5,12.5,0,1,0,25,12.5,12.514,12.514,0,0,0,12.5,0Zm3.109,12.94H13.575v7.248H10.562V12.94H9.129V10.378h1.432V8.721A2.826,2.826,0,0,1,13.6,5.68l2.233.009V8.175H14.215a.614.614,0,0,0-.639.7v1.505h2.3Z"></path>
                    </g>
                </svg>
            </a></li>

            <li><a href="#">
                <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                     viewBox="0 0 25 25">
                    <g id="Color">
                        <g id="_02.YouTube" data-name="02.YouTube">
                            <path id="Path_2" data-name="Path 2" d="M65.46,67.773l3.467-2.012L65.46,63.74Z"
                                  transform="translate(-54.694 -53.256)"></path>
                            <path id="Path_3" data-name="Path 3"
                                  d="M12.5,0A12.5,12.5,0,1,0,25,12.5,12.5,12.5,0,0,0,12.5,0Zm6.579,14.712A2.488,2.488,0,0,1,16.59,17.2H8.41a2.488,2.488,0,0,1-2.488-2.49V10.288A2.488,2.488,0,0,1,8.41,7.8H16.59a2.488,2.488,0,0,1,2.488,2.49Z"></path>
                        </g>
                    </g>
                </svg>
            </a></li>
            <li><a href="#">
                <svg id="whatsapp" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
                    <path id="Path_1354" data-name="Path 1354"
                          d="M12.5,25A12.5,12.5,0,1,0,0,12.5,12.5,12.5,0,0,0,12.5,25Z" transform="translate(0 0)"
                          fill-rule="evenodd"></path>
                    <path id="Path_1355" data-name="Path 1355"
                          d="M20.2,27.229a6.808,6.808,0,0,1-3.285-.839l-3.763,1.2,1.227-3.618a6.675,6.675,0,0,1-.975-3.482,6.8,6.8,0,1,1,6.8,6.744Zm0-12.414a5.7,5.7,0,0,0-5.715,5.67,5.612,5.612,0,0,0,1.089,3.325l-.715,2.108,2.2-.7a5.685,5.685,0,1,0,3.144-10.4Zm3.432,7.224c-.042-.069-.153-.111-.319-.193s-.988-.483-1.138-.538-.264-.083-.375.083-.431.538-.528.65-.194.125-.361.042a4.558,4.558,0,0,1-1.34-.821,4.978,4.978,0,0,1-.927-1.144c-.1-.166-.01-.255.073-.337s.167-.193.25-.29a1.118,1.118,0,0,0,.166-.276.3.3,0,0,0-.014-.29c-.041-.083-.375-.9-.514-1.227s-.278-.276-.375-.276-.208-.014-.319-.014a.615.615,0,0,0-.444.207,1.85,1.85,0,0,0-.583,1.379,3.2,3.2,0,0,0,.68,1.71,6.794,6.794,0,0,0,2.846,2.5c1.7.662,1.694.441,2,.413a1.684,1.684,0,0,0,1.125-.786,1.378,1.378,0,0,0,.1-.786Z"
                          transform="translate(-7.674 -7.972)" fill="#fff" fill-rule="evenodd"></path>
                </svg>
            </a></li>
        </ul>
    </div>
);


const StyledComponent = styled.aside`
    padding-top: 150px;
    padding-bottom: 95px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    position: fixed;

    /* Tablet desktop :768px. */
    @media (min-width: 768px) and (max-width: 991px) {
        padding-top: 160px;
    }


    .mt-2, .my-2 {
        margin-top: 15px !important;
    }

    .social ul {
        display: flex;
        gap: 10px;
    }

    .accordion-button:not(.collapsed) {
        font-weight: bold !important;
        color: black !important;
    }

    h2.accordion-header button {
        background: no-repeat;
        border: none;
        font-size: 18px;
        font-weight: 400;
        line-height: 21px;
        padding: 0;
        color: #707070;
        //margin-bottom: 15px;
    }


    ul.submenu {
        margin-top: 15px;
        padding-bottom: 0px;
        display: flex;
        gap: 10px;

        li {
            padding-left: 15px;

            a {
                font-size: 14px !important;
                font-weight: 400;
                line-height: 20px;
                color: #000;

                &.active-link {
                    border-bottom: 1px solid black;
                }
            }
        }
    }

    ul {
        display: flex;
        flex-direction: column;

        li {
            a {
                font-size: 18px !important;
                font-weight: 400;
                line-height: 21px;
                color: #707070;

                &.active-link {
                    font-weight: bold;
                    color: #000000;
                }
            }
        }
    }

    .menu-bottom__info__single p,
    .menu-bottom {
        &__social {
            p {
                font-size: 12px;
                color: rgba(0, 0, 0, 0.5);
                margin-bottom: 10px;
            }

            &__single {
                p {
                    color: rgba(0, 0, 0, 0.1);
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 14px;
                }
            }
        }
    }

    .menu-bottom__info__single a,
    .menu-bottom__social h5 {
        font-size: 14px;
        font-weight: 400;
        line-height: 16px;
    }

    .menu-bottom {
        flex-direction: column;
        justify-content: space-between;
        position: absolute;
        bottom: 200px;
        left: 0;

        @media (min-width: 1500px) and (max-width: 1600px) {
            bottom: 100px;
        }

        /* Normal desktop :1200px. */
        @media (min-width: 1200px) and (max-width: 1500px) {

            bottom: 100px;
        }


        /* Normal desktop :992px. */
        @media (min-width: 992px) and (max-width: 1200px) {

            bottom: 100px;
        }


        /* Tablet desktop :768px. */
        @media (min-width: 768px) and (max-width: 991px) {

            bottom: 100px;
        }
    }

    .menu-bottom__social ul {
        flex-direction: unset;
    }

    @media (max-width: 767px) {
        display: none;
    }
`;


export default React.memo(MyComponent);
